import axios from "axios";

const configuredApiUrl = process.env.REACT_APP_API_URL;
const protocol = process.env.REACT_APP_PROTOCOLO || window.location.protocol.replace(":", "");
const host = process.env.REACT_APP_BASE_URL;
const port = process.env.REACT_APP_API_PORT;
const legacyApiUrl = host
    ? `${protocol}://${host}${port ? `:${port}` : ""}`
    : window.location.origin;

const apiBaseUrl = configuredApiUrl || (process.env.NODE_ENV === "production" ? "/api" : legacyApiUrl);

const api = axios.create({
    baseURL: apiBaseUrl.replace(/\/$/, ""),
    timeout: 20000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("x-access-token");
    if (token) {
        config.headers = config.headers || {};
        config.headers["x-access-token"] = token;
    }
    return config;
});

// Interceptor: se o token expirar → remove tudo e redireciona
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const requestUrl = error.config?.url || "";
        const isPublicAuthRequest = /\/(?:auth\/)?(?:login|register|recuperarSenha|passwordrecover)(?:\/|\?|$)/.test(requestUrl);
        if (error.response && error.response.status === 401 && !isPublicAuthRequest) {
            alert("Token expirado ou inválido. Faça login novamente!");

            localStorage.removeItem("x-access-token");
            localStorage.removeItem("x-user-id");
            localStorage.removeItem("x-user-mat-id");
            localStorage.removeItem("x-user-tipo");
            localStorage.removeItem("x-permissions");
            localStorage.removeItem("x-role-key");

            window.location.href = "/";
        }
        return Promise.reject(error);
    }
);

export default api;
